import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './users_style.css';
import Swal from "sweetalert2";
import { FaExclamationCircle } from 'react-icons/fa';

const UpdateUserComponent = ({ userId, onClose, onUpdate }) => {
    const [userData, setUserData] = useState(null);
    const [currentView, setCurrentView] = useState('perfil');
    const [errorMessage, setErrorMessage] = useState('');

    const [userProfiles, setUserProfiles] = useState([]);
    const [areas, setAreas] = useState([]);
    const [roles, setRoles] = useState([]);
    const [permissions, setPermissions] = useState([]);
    const [modules, setModules] = useState([]);
    const [isUpdating, setIsUpdating] = useState(false);

    useEffect(() => {
        // Obtención de datos del usuario
        const fetchUserData = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_URL_BACKEND}/api/v1/users/${userId}`, {
                    headers: {
                        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                    },
                });
                setUserData(response.data.data[0]);
            } catch (error) {
                console.error(error);
            }
        };
        fetchUserData();
    }, [userId]);

    const handleUpdate = async () => {
        setIsUpdating(true); 
        try {
            const updatedData = {
                first_name: document.getElementById("first_name").value,
                last_name: document.getElementById("last_name").value,
                email: document.getElementById("email").value,
                role_id: document.getElementById("role_id").value,
                area_id: document.getElementById("area_id").value,
                user_profile: document.getElementById("user_type").value,
            };
            const password = document.getElementById("password").value;
            const confirm_password = document.getElementById("confirm_password").value;

            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            // Validación de campos obligatorios
            const missingFields = [];
            if (!updatedData.first_name) missingFields.push("Nombre");
            if (!updatedData.last_name) missingFields.push("Apellido");
            if (!updatedData.email) missingFields.push("Correo Electrónico");
            if (!updatedData.role_id) missingFields.push("Rol de usuario");
            if (!updatedData.area_id) missingFields.push("Area");
            if (!updatedData.user_profile) missingFields.push("Perfil de usuario");

            if (missingFields.length > 0) {
                setErrorMessage(`Los siguientes campos son obligatorios: ${missingFields.join(', ')}.`);
                return;
            } else if (!emailRegex.test(updatedData.email)) {
                setErrorMessage("Por favor, ingrese un correo electrónico válido");
                return false;
            }

            // Validación de contraseña
            if (password && password !== confirm_password) {
                setErrorMessage("Las contraseñas no coinciden.");
                return;
            }

            setErrorMessage('');

            if (password) {
                updatedData.password = password; // Solo añade la contraseña si se proporciona
            }

            const res = await axios.put(`${process.env.REACT_APP_URL_BACKEND}/api/v1/users/update/${userId}`, updatedData, {
                headers: {
                    Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                },
            });

            if (res.status === 200) {
                Swal.fire("¡Actualizado!", "El elemento ha sido actualizado exitosamente.", "success");
                onUpdate();
                onClose();
            } else {
                Swal.fire("Error", "Hubo un error al crear el perfil", "error");
            }
            setIsUpdating(false);
            onUpdate();
            onClose();
        } catch (error) {
            console.error(error);
            Swal.fire("Error", "Hubo un error", "error");
        }
    };

    //Permisos del usuario
    useEffect(() => {
        const fetchPermissions = async () => {
            try {
                const res = await axios.get(`${process.env.REACT_APP_URL_BACKEND}/api/v1/permissions/${userId}`, {
                    headers: {
                        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                    },
                });
                if (Array.isArray(res.data.data)) {
                    setPermissions(res.data.data);
                } else {
                    throw new Error("Unexpected response format");
                }
            } catch (error) {
                console.error(error);
                Swal.fire("Error", "Hubo un error al obtener los permisos del usuario", "error");
            }
        };
        fetchPermissions();
    }, [userId]);

    const handleRadioChange = async (id_permiso, permission) => {
        try {
            // Actualiza el permiso localmente
            setPermissions((prevPermissions) =>
                prevPermissions.map((p) =>
                    p.id === id_permiso ? { ...p, access: permission } : p
                )
            );

            // Envía la actualización al servidor
            await axios.post(
                `${process.env.REACT_APP_URL_BACKEND}/api/v1//permissions/update`,
                {
                    id_user: userId,
                    id_permiso,
                    permission,
                },
                {
                    headers: {
                        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                    },
                }
            );

        } catch (error) {
            console.error(error);
            Swal.fire("Error", "Hubo un error al actualizar el permiso", "error");
        }
    };

    const getAreas = async () =>{
        try {
            const res = await axios.get(`${process.env.REACT_APP_URL_BACKEND}/api/v1/users/getAreas`, {
                headers: {
                    Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                },
            });
            setAreas(res.data.data);
        } catch (error) {
            console.error(error);
        }
    };

    const getRoles = async () =>{
        try {
            const res = await axios.get(`${process.env.REACT_APP_URL_BACKEND}/api/v1/users/getRoles`, {
                headers: {
                    Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                },
            });
            setRoles(res.data.data);
        } catch (error) {
            console.error(error);
        }
    };

    //Obtener perfiles de usuario para el select de user_type
    const getUserProfiles = async () =>{
        try {
            const res = await axios.get(`${process.env.REACT_APP_URL_BACKEND}/api/v1/user_profiles`, {
                headers: {
                    Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                },
            });
            setUserProfiles(res.data.data);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getUserProfiles();
        getAreas();
        getRoles();
    }, []);

    /* Permisos: modulos y submodulos
    const getModules = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_URL_BACKEND}/api/v1/menu_modules`, {
                headers: {
                    Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                },
            });
            if (res.status === 200) {
                const modulesData = res.data.data.map(module => ({
                    ...module,
                    subModuleId: module.subModuleId === '-' ? 0 : module.subModuleId
                }));
                setModules(modulesData);
                const initialPermissions = {};
                modulesData.forEach(module => {
                    initialPermissions[`${module.moduleId}-${module.subModuleId}`] = 0;
                });
            } else {
                Swal.fire("Error", "Hubo un error al obtener los datos eliminados", "error");
            }
        } catch (error) {
            Swal.fire("Error", "Hubo un error al obtener los datos eliminados", "error");
        }
    }; 

    useEffect(() => {
        getModules();
    }, []) */

    if (!userData || areas.length === 0 || roles.length === 0) return <p>Cargando...</p>;

    return (
        <div>
            <div className="btn-group mb-3" role="group" aria-label="Basic example">
                <button type="button" className="btnn me-2" onClick={() => setCurrentView('perfil')}>Perfil</button>
                <button type="button" className="btnn" onClick={() => setCurrentView('permisos')}>Permisos</button>
            </div>

            {currentView === 'perfil' && userData && (
                <div>
                    <form>
                        {/* Los campos del formulario de perfil aquí */}
                        <div className="row mb-3 text-start">
                            <div className="col-md-6 mb-3">
                                <label htmlFor="first_name">Nombre *</label>
                                <input type="text" className="form-control" id="first_name" placeholder="Nombre" defaultValue={userData.first_name} />
                            </div>
                            <div className="col-md-6 mb-3">
                                <label htmlFor="last_name">Apellido *</label>
                                <input type="text" className="form-control" id="last_name" placeholder="Apellido" defaultValue={userData.last_name} />
                            </div>
                            <div className="col-md-6 mb-3">
                                <label htmlFor="email">Correo Electrónico *</label>
                                <input type="email" className="form-control" id="email" placeholder="Correo" defaultValue={userData.email} />
                            </div>
                            <div className="col-md-6 mb-3">
                                <label htmlFor="role_id">Permisos *</label>
                                <select className="form-select" id="role_id" defaultValue={userData.role_id}>
                                    {roles.map((rol) => (
                                        <option key={rol.id} value={rol.id}>
                                            {rol.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-md-6 mb-3">
                                <label htmlFor="area_id">Área *</label>
                                <select className="form-select" id="area_id" defaultValue={userData.area_id}>
                                    <option value="">Elija una opción</option>
                                    {areas.map((area) => (
                                        <option key={area.id} value={area.id}>
                                            {area.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-md-6 mb-3">
                                <label htmlFor="user_type">Perfil de usuarios *</label>
                                <select className="form-select" id="user_type" defaultValue={userData.user_profile}>
                                    <option value="">Elija una opción</option>
                                    {userProfiles.map((userProfile) => (
                                        <option key={userProfile.id} value={userProfile.id}>
                                            {userProfile.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-md-6 mb-3">
                                <label htmlFor="password">Contraseña *</label>
                                <input type="password" className="form-control" id="password" placeholder="Contraseña" />
                                <small className="text-muted small-text">Deja este campo vacío si no deseas cambiar la contraseña</small>
                            </div>
                            <div className="col-md-6 mb-3">
                                <label htmlFor="confirm_password">Confirmar Contraseña *</label>
                                <input type="password" className="form-control" id="confirm_password" placeholder="Confirmar Contraseña" />
                                <small className="text-muted small-text">Deja este campo vacío si no deseas cambiar la contraseña</small>
                            </div>
                        </div>
                        {errorMessage && <div className="error-message"><FaExclamationCircle style={{ color: '#721c24' }} />{errorMessage}</div>} {/* Mostrar el mensaje de error aquí */}
                    </form>
                    <div className="mt-3">
                        <button className="btn btn-success me-2" onClick={handleUpdate}  disabled={isUpdating}>Actualizar</button>
                        <button className="btn btn-danger" onClick={onClose}>Cancelar</button>
                    </div>
                </div>
            )}

            {currentView === 'permisos' && userData && (
                <div>
                    <div className='table-responsive create-profile'>
                        <table className="table table-inverse table-hover table-striped table-bordered dataTable no-footer" role="grid">
                            <thead>
                                <tr>
                                    <th>Módulo</th>
                                    <th>Sub-módulo</th>
                                    <th>Sin Acceso</th>
                                    <th>Con Acceso</th>
                                </tr>
                            </thead>
                            <tbody>
                                {permissions.map((permission) => (
                                    <tr key={permission.id} data-master-id={permission.id}>
                                        <td>{permission.name}</td>
                                        <td></td>
                                        <td>
                                            <input
                                                type="radio"
                                                checked={!permission.access}
                                                onChange={() => handleRadioChange(permission.id, false)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="radio"
                                                checked={permission.access}
                                                onChange={() => handleRadioChange(permission.id, true)}
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </div>
    );
};

export default UpdateUserComponent;
